module.exports = __webpack_public_path__ + "843b656f72f58bf37d895fa6f95b678f.MP3";